import { render, staticRenderFns } from "./UPR.vue?vue&type=template&id=18ef52da&scoped=true&"
import script from "./UPR.vue?vue&type=script&lang=js&"
export * from "./UPR.vue?vue&type=script&lang=js&"
import style0 from "./UPR.vue?vue&type=style&index=0&id=18ef52da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef52da",
  null
  
)

export default component.exports